/**
 * Tab switching script
 *
 * @since 1.0.0
 * @package uma
 */

(function($) {
    $('.tabs .tab-links a').on('click', function(e) {
        e.preventDefault();

        var currentAttrValue = $(this).attr('href');

        // Show/Hide Tabs
        $('.tabs ' + currentAttrValue).addClass('active').siblings().removeClass('active');

        // Change/remove current tab to active
        $(this).parent('li').addClass('active').siblings().removeClass('active');


    });

    $('.tab-content .tab .mobile-dropdown a').on('click', function(e) {
        e.preventDefault();

        var currentAttrValue = $(this).attr('href');

        // Change/remove current tab to active
        $(this).parents('.tab').toggleClass('active');

        if ($(this).parents('.tab').hasClass('active')) {
            // Show/Hide Tabs
            $('.tabs ' + currentAttrValue + ' .tab-content-inner').addClass('active');
        } else {
            $('.tabs ' + currentAttrValue + ' .tab-content-inner').removeClass('active');
        }

    });

    /* @TODO : TO DO */
    $(window).bind('load resize', function() {
        var sectionwidth = $('section.tabs-content').width();
        if (sectionwidth > 1199) {
            $('section.tabs-content .tab:first-of-type').addClass('active');
            $('section.tabs-content .tab-links li:first-of-type').addClass('active').siblings().removeClass('active');
            $('.tabs #tab1').siblings().removeClass('active');
        }
    });

    // hash logic
    if (window.location.hash && !$('.has-has-scroll').lenght) {

        $(window).load(function() {
            var targetTabLink = $('.tabs .tab-links li.' + window.location.hash.slice(1) + ' a');
            var mobileTargetTabLink = $('.tabs .tab.' + window.location.hash.slice(1) + ' .tab-content-inner');
            targetTabLink.click();
            mobileTargetTabLink.addClass('active');
        });

    }
})(jQuery);
